<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-input label="Location">
                                <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Brand">
                                <a-select showSearch v-model="inputBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brand" @select="getSubBrandData" @change="clearSubBrand">
                                    <a-select-option v-for="brandOption in brandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                  
                    <div v-if="subBrandOptions.length > 0" class="row">
                        <div class="col-md-4">
                            <base-input label="Sub Brand">
                                <a-select v-model="inputSubBrands" placeholder="Select Sub Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" mode="multiple" showSearch >
                                    <a-select-option
                                    v-for="sub_brand_option in subBrandOptions"
                                    :key="sub_brand_option.id"
                                    :value="sub_brand_option.id"
                                    >{{ sub_brand_option.name }}
                                    </a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Product Group">
                                <a-select mode="multiple" v-model="inputProductGroup" showSearch placeholder="All Product Group" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="productGroupOption in productGroupOptions" :key="productGroupOption.id" :value="productGroupOption.id">{{productGroupOption.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Division">
                                <a-select mode="multiple" v-model="inputDivision" showSearch placeholder="All Division" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="divisionOption in divisionOptions" :key="divisionOption.id" :value="divisionOption.id">{{divisionOption.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isSeparateSite" v-if="site_type == 'ho'">
                        Separate per site
                    </base-checkbox>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
            VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: 'date,division_id', value: 'Date,Division'},
                    {key: 'date,product_group_id', value: 'Date,Product Group'},
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                // locationPath: [],

                inputSortBy: 'document_date',
                sortOptions: [
                    {key: 'document_date', value: 'Document Date'},
                    {key: 'date,quantity', value: 'Date and Quantity'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: false,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                salesInvoiceReports: [],
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputProductGroup: [],
                productGroupOptions: [],
                inputBrands: [],
                inputDivision: [],
                divisionOptions: []

            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.inputGroupBy = 'date,division_id'
            await component_x.getBrandOptions();
            await component_x.getProductGroupOptions();
            await component_x.getDivisionOptions();

        },
        watch: {
            inputGroupBy: function(val){
                if(this.inputGroupBy == "date,division_id"){
                    this.sortOptions = [
                        {key: 'document_date', value: 'Document Date'},
                        {key: 'date,quantity', value: 'Date and Quantity'},
                        {key: "date,division_id", value: "Date and Division"}
                    ]
                }else if(this.inputGroupBy == "date,product_group_id"){
                    this.sortOptions = [
                        {key: 'document_date', value: 'Document Date'},
                        {key: 'date,quantity', value: 'Date and Quantity'},
                        {key: "date,product_group_id", value: "Date and Product Group"}
                    ]
                }
            } 
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            changeParams(params){
                this.params = params
            },
            async findName(inputArray, optionsArray){
                let data = []
                inputArray.forEach((el) =>{
                    data.push(optionsArray.find(x => x.id === el).name)
                })
                return data
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = '' 
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group_by": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "is_separate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "product_group_id": this.inputProductGroup.toString(),
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString()    
                }

                if(this.inputSite.length > 0){
                    let arr = await this.findName(this.inputSite, this.siteOptions)
                    filter_header += `Site (${arr})`
                }else{
                    filter_header += "Site (All Site)"
                }

                if(this.inputProductGroup != undefined && this.inputProductGroup.length != 0){
                    let arr = await this.findName(this.inputProductGroup, this.productGroupOptions)
                    filter_header += `, Product Group (${arr})`
                }

                if(this.inputBrands != undefined && this.inputBrands.length != 0){
                    let arr = await this.findName(this.inputBrands, this.brandOptions)
                    filter_header += `, Brand (${arr})`
                }   

                if(this.inputSubBrands != undefined && this.inputSubBrands.length != 0){
                    let arr = await this.findName(this.inputSubBrands, this.subBrandOptions)
                    filter_header += `, Sub brand (${arr})`
                }

                if(this.inputDivision != undefined && this.inputDivision.length != 0){
                    let arr = await this.findName(this.inputDivision, this.divisionOptions)
                    filter_header += `, Division (${arr})`
                }
            
                if(this.isSeparateSite == true){
                    filter_header += ", Seperated each site"
                }

                // console.log(filter_header,this.params)

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice_margin?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                
                let design_x = 0
                let design_y = 0

                let group_text = ""
                if(this.inputGroupBy != ''){
                    group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                }

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    // if(this.isShowDetail == true){
                    //     doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                    // }

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let description = "Description"
                    if(this.inputGroupBy == "date,division_id"){
                        description = "Division Name"
                    }else if(this.inputGroupBy == "date,product_group_id"){
                        description = "Product Group Name"
                    }

                    let headers = [];
                    headers = [
                        [
                            {content: '#', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Month', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Day', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Year', styles: {halign: 'center', valign: 'center'}},
                            {content: description, styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Value', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Cost of Goods Sold', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Margin', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Margin Value', styles: {halign: 'center', valign: 'center'}},
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.salesInvoiceReports = siteSpecific[x].sales_report

                        let total_qty = 0
                        let total_sales_value = 0
                        let total_sales_margin_value = 0
                        let total_cost_goods_sold = 0

                        let grand_qty = 0
                        let grand_sales_value = 0
                        let grand_sales_margin_value = 0
                        let grand_cost_goods_sold = 0

                        if(x > 0 && this.salesInvoiceReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.salesInvoiceReports.length > 0){

                            let number = 1
                            for(let i=0; i < this.salesInvoiceReports.length; i++){
                                let reportLine = this.salesInvoiceReports[i]

                                let grouper_name = moment(reportLine.document_date).format('MMMM DD YYYY')
                                if(this.inputGroupBy != ''){
                                    if(grouper == 'start'){
                                        let detail_header = [
                                            {content: `${number}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                            ];
                                        number += 1
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != moment(reportLine.document_date).format('MMMM DD YYYY')){
                                            let detail_header = [{content: `${number}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                            ];
                                            number += 1
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper  = moment(reportLine.document_date).format('MMMM DD YYYY')
                                }

                                let description = reportLine.product_group_name ? reportLine.product_group_name : reportLine.division_name
                                let detail = []
                                detail = [
                                        "",
                                        reportLine.month,
                                        reportLine.day,
                                        reportLine.year,
                                        description,
                                        reportLine.quantity,
                                        this.convertToCurrency(Number(reportLine.sales_value)),
                                        this.convertToCurrency(Number(reportLine.cost_goods_sold)),
                                        Math.round(reportLine.sales_margin).toFixed(2) + '%',
                                        this.convertToCurrency(Number(reportLine.sales_margin_value)),
                                ]
                                

                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.quantity)
                                total_sales_value += Number(reportLine.sales_value)
                                total_sales_margin_value += Number(reportLine.sales_margin_value)
                                total_cost_goods_sold += Number(reportLine.cost_goods_sold)

                                grand_qty += Number(reportLine.quantity)
                                grand_sales_value += Number(reportLine.sales_value)
                                grand_sales_margin_value += Number(reportLine.sales_margin_value)
                                grand_cost_goods_sold += Number(reportLine.cost_goods_sold)

                                if(i == this.salesInvoiceReports.length-1){
                                    if(this.inputGroupBy != ''){
                                    let sub_detail = []
                                    let spacer = grouper_name
                                    
                                    sub_detail = ["",
                                            {content: spacer, colSpan:2, styles: {halign: 'center', fontStyle: 'bold'}},"","","Total:",
                                            this.convertToCurrency(total_qty),this.convertToCurrency(total_sales_value),
                                            this.convertToCurrency(total_cost_goods_sold),"",this.convertToCurrency(total_sales_margin_value)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))
                                    }
                                

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    reportData.push(Object.assign({}, ['','','','','Grand Total :', this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_sales_value),this.convertToCurrency(grand_cost_goods_sold),
                                        '',this.convertToCurrency(grand_sales_margin_value)
                                    ]))
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""
                                    
                                    current_grouper = moment(reportLine.document_date).format("DD MMMM YYYY")
                                    next_grouper = moment(this.salesInvoiceReports[i+1].document_date).format("DD MMMM YYYY")
                                
                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            let sub_detail = []

                                            let spacer = grouper_name
                                            sub_detail = ["",
                                                {content: spacer, colSpan:2, styles: {halign: 'center', fontStyle: 'bold'}},"","","Total:",
                                                this.convertToCurrency(total_qty),this.convertToCurrency(total_sales_value),
                                                this.convertToCurrency(total_cost_goods_sold),"",this.convertToCurrency(total_sales_margin_value)
                                            ]
                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_sales_value = 0
                                            total_sales_margin_value = 0
                                            total_cost_goods_sold = 0
                                        }
                                        
                                    }
                                }
                            }
                        }


                        design_x = 290
                        design_y = 200
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Sales Invoice Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(design_x,20,siteSpecific[x].sales_report[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = ''
                            } else {
                                // let sites = this.inputSite
                                // for (var s = 0; s < sites.length; s++) {
                                //     if(s == 0){
                                //         site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                //     } else {
                                //         site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                //     }
                                // }
                            }
                            doc.text(design_x,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let splitTitle = doc.splitTextToSize("Filtered by: " + filter_header, 180);
                        doc.text(15,30,splitTitle);

                        let colStyles = {}

                        colStyles = {
                            0: {cellWidth: 10},
                            1: {cellWidth: 30},
                            2: {cellWidth: 15},
                            3: {cellWidth: 15},
                            4: {cellWidth: 60},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 40},
                            8: {cellWidth: 30},
                            9: {cellWidth: 45},
                        }


                        doc.autoTable({
                            startY: 45,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right',
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });


                    }
                    // end loop

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Sales Invoice" + group_text, design_x, design_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Item_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;

            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                    console.log(dataURL)
                }
                return img.src = url
            },
            async generateExcel(){
                this.spinning = true;
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Sales Invoice Report by " + this.inputGroupBy, {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = ''
                const data_starts_at_row = 10

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 100, height: 90 }
                });

                if(this.inputSite.length > 0){
                    let arr = await this.findName(this.inputSite, this.siteOptions)
                    filter_header += `Site (${arr})`
                }else{
                    filter_header += "Site (All Site)"
                }

                if(this.inputProductGroup != undefined && this.inputProductGroup.length != 0){
                    let arr = await this.findName(this.inputProductGroup, this.productGroupOptions)
                    filter_header += `, Product Group (${arr})`
                }

                if(this.inputBrands != undefined && this.inputBrands.length != 0){
                    let arr = this.findName(this.inputBrands, this.brandOptions)
                    filter_header += `, Brand (${arr})`
                }   

                if(this.inputSubBrands != undefined && this.inputSubBrands.length != 0){
                    let arr = await this.findName(this.inputSubBrands, this.subBrandOptions)
                    filter_header += `, Sub brand (${arr})`
                }

                if(this.inputDivision != undefined && this.inputDivision.length != 0){
                    let arr = await this.findName(this.inputDivision, this.divisionOptions)
                    filter_header += `, Division (${arr})`
                }

                if(this.isSeparateSite == "true"){
                    filter_header += ", Seperated each site"
                }

                sheet.getRow(6).values = ["Sales Invoice Report with Margin"]
                sheet.getRow(7).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(8).values = [`Filtered by: ${filter_header}`]

                let description = "Description"
                if(this.inputGroupBy == "date,division_id"){
                    description = "Division Name"
                }else if(this.inputGroupBy == "date,product_group_id"){
                    description = "Product Group Name"
                }
                //custom header
                sheet.getRow(data_starts_at_row).values = ["#", "Month", "Day", "Year",description,"Qty","Sales Value","Cost of Goods Sold","Sales Margin","Sales Margin Value"];

                sheet.columns = [
                    { key: "#" , width: 'auto' },
                    { key: "month", width: 'auto' },
                    { key: "day", width: 'auto' },
                    { key: "year", width: 'auto' },
                    { key: "description" , width: 'auto' },
                    { key: "qty", width: 'auto' },
                    { key: "sales_value" , width: 'auto' },
                    { key: "cost_goods_sold", width: 'auto' },
                    { key: "sales_margin", width: 'auto' },
                    { key: "sales_margin_value", width: 'auto' },
                ];

                var sales_report = this.JsonData
                // var sales_report = get_request[0].sales_report
                // console.log("details", sales_report)

                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < sales_report.length; i++){
                    const report_detail = sales_report[i]
                        if(report_detail){
                            const rowData = {"#": report_detail["#"], month: report_detail["Month"], day: report_detail["Day"], 
                            year: report_detail["Year"], qty: report_detail["Qty"],description: report_detail[`${description}`],
                            sales_value: report_detail["Sales Value"], 
                            cost_goods_sold: report_detail["Cost of Goods Sold"] , sales_margin: report_detail["Sales Margin"],
                            sales_margin_value: report_detail["Sales Margin Value"],}
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(6).font = { bold: true, size: 16 };
                sheet.getRow(6).height = 20;
                sheet.getRow(9).font = { bold: true };

                sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                })

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `saleReportMargin.xlsx`);
                });
                this.JsonData = []
                this.spinning =false
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group_by": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "is_separate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "product_group_id": this.inputProductGroup.toString(),
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString()    
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice_margin?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }

                console.log(get_request)
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let description = "Description"
                    if(this.inputGroupBy == "date,division_id"){
                        description = "Division Name"
                    }else if(this.inputGroupBy == "date,product_group_id"){
                        description = "Product Group Name"
                    }
                    let headers = ["#", "Month", "Day", "Year", description, "Qty", "Sales Value", "Cost of Goods Sold", "Sales Margin", "Sales Margin Value"];
                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.salesInvoiceReports = siteSpecific[x].sales_report

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.salesInvoiceReports.length > 0){
                            let total_qty = 0
                            let total_sales_value = 0
                            let total_sales_margin_value = 0
                            let total_cost_goods_sold = 0

                            let grand_qty = 0
                            let grand_sales_value = 0
                            let grand_sales_margin_value = 0
                            let grand_cost_goods_sold = 0

                            let grouper = 'start'
                            for(let i=0; i < this.salesInvoiceReports.length; i++){
                                let reportLine = this.salesInvoiceReports[i]
                                let grouper_name = reportLine.document_date

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.document_date){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.document_date
                                let description = reportLine.product_group_name ? reportLine.product_group_name : reportLine.division_name

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.month,
                                    reportLine.day,
                                    reportLine.year,
                                    description,
                                    reportLine.quantity,
                                    this.convertToCurrency(Number(reportLine.sales_value)),
                                    this.convertToCurrency(Number(reportLine.cost_goods_sold)),
                                    Math.round(reportLine.sales_margin).toFixed(2) + '%',
                                    this.convertToCurrency(Number(reportLine.sales_margin_value)),
                                ]
                                total_qty += Number(reportLine.quantity)
                                total_sales_value += Number(reportLine.sales_value)
                                total_cost_goods_sold += Number(reportLine.cost_goods_sold)
                                total_sales_margin_value += Number(reportLine.sales_margin_value)

                                grand_qty += Number(reportLine.quantity)
                                grand_sales_value += Number(reportLine.sales_value)
                                grand_cost_goods_sold += Number(reportLine.cost_goods_sold)
                                grand_sales_margin_value += Number(reportLine.sales_margin_value)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.salesInvoiceReports.length-1){
                                    //Subtotal
                                    sub_detail = ['','','','','Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_sales_value),
                                            this.convertToCurrency(total_cost_goods_sold),
                                            '',
                                            this.convertToCurrency(total_sales_margin_value)
                                        ]
                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    let grand_detail = ['','','','','Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_sales_value),
                                        this.convertToCurrency(grand_cost_goods_sold),
                                        '',
                                        this.convertToCurrency(grand_sales_margin_value)
                                    ]
                                    reportData.push(Object.assign({}, grand_detail));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.document_date
                                    next_grouper = this.salesInvoiceReports[i+1].document_date

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        sub_detail = ['','','','','Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_sales_value),
                                            this.convertToCurrency(total_cost_goods_sold),
                                            '',
                                            this.convertToCurrency(total_sales_margin_value)
                                        ]

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_sales_value = 0
                                        total_cost_goods_sold = 0
                                        total_sales_margin_value = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].sales_report[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Sales Invoice Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
             this.JsonData = [];
            },
            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?mode=all",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },

            async getProductGroupOptions() {
                var product_groups = await HTTPRequest.getRequest(
                    this.endPoint + "/product_groups/get_valid_product_groups",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.productGroupOptions = product_groups;  
            },
            async getDivisionOptions() {
                var divisions = await HTTPRequest.getRequest(
                    this.endPoint + "/categories/get_valid_categories?level=1",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.divisionOptions = divisions;  
            },


            async getSubBrandData() {
                if (this.inputBrands != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_ids=" +
                        this.inputBrands,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
